
import React from "react";
import { makeStyles } from "@material-ui/core/styles"
import { runInAction } from "mobx"

import globalStyles from "./theme/global"
import { getContext } from "./simgate";

const localStyles = theme => ({
  "processingIcon": {
    animationName: "$rotate",
    animationDuration: "1s",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite"
  },
  "@keyframes rotate": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(180deg)"
    }
  }
})

/*
    Generate class names from both Global & Local styles
*/
export const useClasses = makeStyles(theme => {
  return {
    ...globalStyles(theme),
    ...localStyles(theme)
  }
})

export const joinClasses = (...classes) => classes.filter(item => item !== null).join(" ");

export const strLenToFontSize = ({
  string = "",
  baseLen = 20,
  baseSize = 1,
  multiplier = 5,
  maxSize = 6,
  minSize = 1,
  round = true
}) => {
  let size = baseSize
  size = size - (string.length - baseLen) * multiplier
  if (size < minSize) size = minSize
  if (size > maxSize) size = maxSize
  return round ? Math.floor(size) : size
}

let app = null;
export const ensureApp = (AppStore = null) => {
  if (app) { return app; }
  app = new AppStore();
  app.changeView = changeView;
  return app;
}

export const changeView = (newView, viewData = {}) => {
  if (!app) {
    throw new Error("`ensureApp` must be called before calling `changeView`");
  }

  window.closeLoadingOverlay();
  runInAction(() => {
    app.ready = true;
    app.viewData = viewData;
    app.currentView = newView;
  });
}

export const AppContext = React.createContext(null);